import React, { useState, useRef, useEffect } from "react";
import ArrowL from "../../assets/images/arrow_l.svg"
import ArrowR from "../../assets/images/arrow_r.svg"

import "../../style/spinner.scss";
import "./index.scss"; 

const Slider = ({ images }) => {
  const [currentIndex, setCurrentIndex] = useState(1); // Начинаем с первого реального слайда
  const [slideWidth, setSlideWidth] = useState(window.innerWidth > 576 ? 100 : 200);
  // const [loadedImages, setLoadedImages] = useState(new Array(images.length).fill(false)); // Состояние загрузки изображений
  const slidesRef = useRef(null);

    const [loadedImages, setLoadedImages] = useState({}); // Отслеживаем состояние загрузки каждого изображения
  
    const handleImageLoad = (src) => {
      setLoadedImages((prev) => ({ ...prev, [src]: true })); // Помечаем изображение как загруженное
    };

  useEffect(() => {
    // Обновляем slideWidth при изменении ширины экрана
    const handleResize = () => {
      setSlideWidth(window.innerWidth > 576 ? 100 : 200);
    };

    window.addEventListener("resize", handleResize); // Добавляем обработчик события resize
    return () => {
      window.removeEventListener("resize", handleResize); // Удаляем обработчик при размонтировании
    };
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 4000); // Автоматический переход каждые 10 секунды

    return () => clearInterval(interval); // Очищаем интервал при размонтировании компонента
  }, []);


  const nextSlide = () => {
    setCurrentIndex((prevIndex) => {
      const newIndex = prevIndex + 1;
      if (newIndex === images.length + 1) { // Если достигаем копии последнего
        setTimeout(() => {
          slidesRef.current.style.transition = "none";
          setCurrentIndex(1); // Перемещаемся на первый реальный слайд
        }, 500); // Время анимации
      }
      return newIndex;
    });
    slidesRef.current.style.transition = "transform 0.5s ease";
    slidesRef.current.style.transform = `translateX(-${currentIndex * slideWidth}%)`;
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => {
      const newIndex = prevIndex - 1;
      if (newIndex === 0) { // Если достигаем копии первого
        setTimeout(() => {
          slidesRef.current.style.transition = "none";
          setCurrentIndex(images.length); // Перемещаемся на последний реальный слайд
        }, 500); // Время анимации
      }
      return newIndex;
    });
    slidesRef.current.style.transition = "transform 0.5s ease";
    slidesRef.current.style.transform = `translateX(-${currentIndex * slideWidth}%)`;
  };

  return (
    <div className="slider">
      {!loadedImages[images[0]] && (
        <div className="spinner-wrap">
          <div className="spinner"></div>
        </div>
      )}
      <div className="slides" ref={slidesRef} style={{ transform: `translateX(-${currentIndex * slideWidth}%)` }}>
        <img src={images[images.length - 1]} alt="" />
        {images.map((image, index) => (
            <img key={index} src={image} alt={`Slide ${index + 1}`} />
          ))}
        <img src={images[0]} alt="" onLoad={() => handleImageLoad(images[0])}/>
      </div>
      <button className="btn-slider prev" onClick={prevSlide} aria-label="Swipe Right"><img src={ArrowL} alt=""/></button>
      <button className="btn-slider next" onClick={nextSlide} aria-label="Swipe Left"><img src={ArrowR} alt=""/></button>
    </div>
  );
};

export default Slider;